<template>
  <!--
    	作者：kmdshop
    	时间：2019-10-26
    	描述：商品管理-商品编辑-高级设置
    -->
  <div class="buy-set-content pl16 pr16">
    <div>




      <!--积分设置-->
      <div class="common-form mt50">积分设置</div>
      <el-form-item label="是否开启积分赠送：">
        <el-radio-group v-model="form.model.is_points_gift">
          <el-radio :label="1">开启</el-radio>
          <el-radio :label="0">关闭</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="是否允许使用积分抵扣：">
        <el-radio-group v-model="form.model.is_points_discount">
          <el-radio :label="1">允许</el-radio>
          <el-radio :label="0">不允许</el-radio>
        </el-radio-group>
      </el-form-item>


  


      <!-- <el-form-item label="业绩">
        <el-input type="number" min="0" v-model="form.model.achievement" class="max-w460"></el-input>
        <div class="gray9"></div>
      </el-form-item> -->


      <!--福利金设置-->
      <!-- <div v-if="form.welfare.status == true || form.welfare.status == 'true'">
        <div class="common-form mt50"  >福利金设置</div>
        <el-form-item label="是否允许使用福利金抵扣：" >
          <el-radio-group v-model="form.model.is_open_welfare_discount">
            <el-radio :label="1">允许</el-radio>
            <el-radio :label="0">不允许</el-radio>
          </el-radio-group>
        </el-form-item>


        <el-form-item label="抵扣类型："  v-if="form.model.is_open_welfare_discount == 1 ">
          <el-radio-group v-model="form.model.is_welfare_discount_type">
            <el-radio :label="1">固定数量</el-radio>
            <el-radio :label="2">比例</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="福利金抵扣数量" v-if="form.model.is_open_welfare_discount == 1">
          <el-input type="number" min="0" v-model="form.model.is_welfare_discount" class="max-w460"></el-input>
          <span v-if="form.model.is_welfare_discount_type == 1">个</span>
          <span v-if="form.model.is_welfare_discount_type == 2">%</span>
          <div class="gray9">
            说明：抵扣针对单个产品生效，不是针对订单总额；抵扣只针对特定商家开启福利金抵扣的商品;
            

          </div>
        </el-form-item>
      </div> -->
     

      <!--跳转设置-->
      <!-- <div class="common-form mt50">小程序跳转设置</div>
      <el-form-item label="按钮名称：">
        <el-input type="text" v-model="form.model.mini_name" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="小程序appid：">
        <el-input type="text" v-model="form.model.mini_appid" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="小程序跳转页面">
        <el-input type="text" v-model="form.model.mini_page" class="max-w460"></el-input>
        <div class="gray9">填写跳转页面,可携带参数$user_id,如/pages/index/index?user_id=$user_id</div>
      </el-form-item> -->
      <!--上下架功能-->
      <!-- <div class="common-form mt50">自动上下架</div>
      <el-form-item label="是否开启自动上下架：">
        <el-radio-group v-model="form.model.automatic_shelves">
          <el-radio :label="0">关闭</el-radio>
          <el-radio :label="1">开启</el-radio>
        </el-radio-group>
      </el-form-item>
      <template v-if="Number(form.model.automatic_shelves) === 1">
        <el-date-picker v-model="form.model.shelves_time" type="datetimerange" :picker-options="pickerOptions" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" align="right"></el-date-picker>
      </template> -->

      <!--预售时间-->
      <!-- <div class="common-form mt50">预售时间设置</div>
      <el-form-item label="预售时间：">
        <div class="block">
          <el-date-picker :picker-options="pickerOptions1" v-model="form.model.sale_time" type="datetime" placeholder="选择日期时间"></el-date-picker>
        </div>
      </el-form-item>

      <el-form-item label="发货时间：">
        <div class="block">
          <el-date-picker :picker-options="pickerOptions1" v-model="form.model.delivery_time" type="datetime" placeholder="选择日期时间"></el-date-picker>
        </div>
      </el-form-item> -->

      <!--其他设置-->
      <div class="common-form mt50">其他设置</div>
       
      <el-form-item label="所在地：">
        <el-select v-model="form.model.province_id" placeholder="省" @change="initCity">
          <el-option :label="item.name" :value="item.id" v-for="(item, index) in areaList" :key="index"></el-option>
        </el-select>
        <el-select v-if="Number(form.model.province_id) !== 0" v-model="form.model.city_id" placeholder="市">
          <el-option :label="item1.name" :value="item1.id" v-for="(item1, index1) in areaList[form.model.province_id]['city']" :key="index1"></el-option>
        </el-select>
        <el-button size="mini" @click="deleteArea()">清除地区</el-button>
      </el-form-item>
      <el-form-item label="商品有效期：">
        <el-input type="number" min="0" v-model="form.model.product_days" class="max-w460"></el-input>&nbsp;&nbsp;天
      </el-form-item>
      <!-- 商品链接 -->
      <el-form-item prop="model.link_status" label="商品链接显示：">
        <el-radio-group v-model="form.model.link_status">
          <!-- <el-radio :label="0">继承全局</el-radio> -->
          <el-radio :label="1">显示</el-radio>
          <el-radio :label="2">关闭</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="立即购买文本：" prop="model.setting.text.buy_text">
        <el-input v-model="form.model.setting.text.buy_text" class="max-w460"></el-input>
        <div class="gray9"> 说明：商品详情 立即购买 按钮文本自定义更改 </div>
      </el-form-item>

      <!-- 商品链接显示时间 -->
      <el-form-item label="商品链接显示：" v-if="Number(form.model.link_status) === 1">
        <div class="block">
          <el-date-picker v-model="form.timer" type="datetimerange" :picker-options="pickerOptions" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @change="getSTime" align="center"></el-date-picker>
        </div>
      </el-form-item>
      <el-form-item label="初始销量：">
        <el-input type="number" min="0" v-model="form.model.sales_initial" class="max-w460"></el-input>
      </el-form-item>
      <!-- <el-form-item label="商品起订数：">
        <el-input type="number" min="0" v-model="form.model.buy_num" class="max-w460"></el-input>
      </el-form-item> -->

      <el-form-item label="平台链接：" prop="model.link">
        <el-input v-model="form.model.link" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="备注：" prop="model.remark">
        <el-input v-model="form.model.remark" class="max-w460"></el-input>
      </el-form-item>
    </div>
  </div>
</template>

<script>
// import select_region from "@/utils/select.region.js";
import select_region from '@/utils/select.district.js';

export default {
  components: {
  },
  data() {
    return {
      index: null,
      the_shelves_time: '',
      // pickerOptions : {
      //   disabledDate:(time)=> {
      //     return time.getTime() < Date.now()-1 * 24 * 3600 * 1000
      //   },
      // },

      //预售时间
      pickerOptions1: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 1 * 24 * 3600 * 1000;
        },
      },

      //新增
      pickerOptions: {
        shortcuts: [{
          text: '接下一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() + 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [end, start]);
          }
        }, {
          text: '接下一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() + 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [end, start]);
          }
        }, {
          text: '接下三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() + 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [end, start]);
          }
        }],
      },
      //转换时间戳
      dateFormat(row, column) {
        // console.log(this.form.model.shelves_time,123456);
        if (row[column.property] > 0) {
          let time = row[column.property] * 1000;
          const date = new Date(time);
          let year = date.getFullYear();
          let month = date.getMonth() + 1;
          let day = date.getDate();
          let getHours = date.getHours();
          let getMinutes = date.getMinutes();
          let getSeconds = date.getSeconds();
          return year + '年' +
            month + '月' +
            day + '日 ' +
            getHours +  //获取当前小时
            getMinutes + //获取当前分
            getSeconds  //获取当前秒
        }
      },
      value1: this.form.model.shelves_time,
      value2: this.form.model.the_shelves_time
    };

  },
  computed: {
    areaList() {
      return select_region
    }
  },
  inject: ['form'],
  methods: {
    // 获取选择的时间
    getSTime(e) {
      var d = new Date(e[0]);
      var youWant = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate() + ' ' + d.getHours() + ':' + d.getMinutes() + ':' + d.getSeconds();
      // console.log(youWant)
      var d2 = new Date(e[1]);
      var youWant2 = d2.getFullYear() + '-' + (d2.getMonth() + 1) + '-' + d2.getDate() + ' ' + d2.getHours() + ':' + d2.getMinutes() + ':' + d2.getSeconds();
      // console.log(youWant2)
      this.form.model.link_start_at = youWant
      this.form.model.link_end_at = youWant2
    },
    /*初始化城市id*/
    initCity() {
      this.form.model.city_id = "";
    },
    deleteArea() {
      this.form.model.province_id = 0;
      this.form.model.city_id = 0;
    },
    handle: function () {
      var startAt = new Date(this.date) * 1000 / 1000;
      if (startAt < Date.now()) {
        this.date = new Date();
      }
    },

  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/product/product/part/Buyset.vue